import { createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import promise from 'redux-promise-middleware';
import allReducers from './reducers/index';

const Store = createStore(allReducers, applyMiddleware(promise()));

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const Store = createStore(allReducers, composeEnhancers(
//     applyMiddleware(logger, promise()))
// );
export default Store;
